import React from 'react';
// import { withPrefix } from 'gatsby';
import LeftNavResourceLinks from './LeftNavResourceLink';

const links = [
  {
    title: 'Toolkit license',
    href: "/toolkit_license/",
  },
  {
    title: 'Submit a GitHub issue',
    href: 'https://github.com/IBMa/equal-access/issues/new/choose',
  },
  {
    title: 'IBM Accessibility Central',
    href: 'https://pages.github.ibm.com/IBMa/able/',
    locked:true,
  },
  {
    title: '#accessibility-at-ibm',
    href: 'https://ibm-studios.slack.com/archives/C036P1CTN',
    locked:true,
  },
];

// shouldOpenNewTabs: true if outbound links should open in a new tab
const CustomResources = () => <LeftNavResourceLinks shouldOpenNewTabs links={links} />;

export default CustomResources;
